module.exports = __webpack_public_path__ + "static/media/rooms.18009333.svg";